export default function ApplicationLogo(props) {
    return (
        <img 
            src="https://dabulgaria.bg/wp-content/themes/dabulgaria2/images/logo/dabulgaria.svg"
            alt="Да, България"
            {...props}
        />
    );
}
